import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {AuthService} from "@app/core";
import {BsModalRef} from "ngx-bootstrap";
import {JobViewService} from "@app/features/customers/customer/jobs-view/service/job-view-service";
import {Subject} from "rxjs";

@Component({
    selector: 'app-job-part-edit',
    templateUrl: './job-part-edit.component.html',
    styleUrls: ['./job-part-edit.component.css']
})
export class JobPartEditComponent implements OnInit {
    @Input() sidepanelData: any;
    @Input() jobType: number = 0;
    @Input() PurchaseOrderReadaccess: boolean = false;
    @Input() jobtodos:any=0;
    @Input() moduleId:any =3;
    public onClose: Subject<boolean>;
    partStatus :any = 'edit_requested';
    showCostPrice:boolean = true;
    showQuantity:boolean= true;
    form: FormGroup;

    constructor(private fb: FormBuilder,
                private authService: AuthService,
                public sidePanelModalRef: BsModalRef,
                private jobViewService: JobViewService,) {}

    ngOnInit(): void {
        if(this.partStatus == 'edit_all' && (this.sidepanelData.Status == 'On Order' || this.sidepanelData.Status == "Available" || this.sidepanelData.Status == "Installed" || this.sidepanelData.Status == "Picked up")){
            this.partStatus = 'edit_ordered';
        }else if(this.partStatus == 'edit_all' && this.sidepanelData.Status == 'Requested'){
            this.partStatus = 'edit_requested';
        }
        this.onClose = new Subject();
        this.PurchaseOrderReadaccess =this.authService.permitted(['Purchaseorder.readaccess']) === true;
        const quantityVal = this.normalizeNumber(this.sidepanelData.Quantity);
        const costPriceVal = this.sidepanelData['Unit cost price'] == '0' ? 0 : this.normalizeNumber(this.sidepanelData['Unit cost price']);
        const salePriceVal = this.sidepanelData['Unit sales price'] == '0' ? 0 : this.normalizeNumber(this.sidepanelData['Unit sales price']);
        this.form = this.fb.group({
            Quantity: [quantityVal !== undefined && quantityVal !== null ? quantityVal : '', [Validators.required, Validators.min(1)]],
            costprice: [costPriceVal !== undefined && costPriceVal !== null ? costPriceVal : '', [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/)]],
            saleprice: [salePriceVal !== undefined && salePriceVal !== null ? salePriceVal : '', [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/)]]
        });

        if((this.partStatus == 'edit_ordered' || this.partStatus == 'edit_available' || this.partStatus === "edit_installed" || this.partStatus === "edit_pickUp") && this.sidepanelData['FulfillType'] != 'General'){
            this.showCostPrice = false;
        }
        if(this.partStatus == 'edit_ordered' || this.partStatus == 'edit_available' || this.partStatus === "edit_installed" || this.partStatus === "edit_pickUp"){
            this.showQuantity = false;
        }

    }

    get f() { return this.form.controls; }

    private normalizeNumber(value: any): number | any {
        if (value === undefined || value === null || value === '') return value;
        let str = String(value).trim();
        str = str.replace(/[\s,]/g, '');
        if (str.includes('.')) {
            const parts = str.split('.');
            if (parts.length > 2) {
                str = parts.slice(0, -1).join('') + '.' + parts.slice(-1);
            }
        }
        return Number(str);
    }

    onSave() {
        if (this.form.invalid) return;
        const quantity = this.normalizeNumber(this.form.get('Quantity').value);
        const costprice = this.normalizeNumber(this.form.get('costprice').value);
        const salesprice = this.normalizeNumber(this.form.get('saleprice').value);
        const id = this.sidepanelData['id'];
        const fulfillType = this.sidepanelData['FulfillType'];
        const partStatus = this.sidepanelData['Status'];
        const jobId = this.sidepanelData['jobId'] != null ? this.sidepanelData['jobId'] : this.sidepanelData['jobid'];
        const moduleId = this.moduleId;
        const jobtodos = this.jobtodos;

        const saveData = { quantity, costprice, salesprice, id, fulfillType, partStatus, jobId ,moduleId,jobtodos};
        this.jobViewService.saveEditPart(saveData).subscribe(response=>{
            this.onClose.next(true);
        })
    }
}
